import * as React from 'react';
import { connect } from 'react-redux'
import {deactivate, setScreen} from "../actions/activation";
import TopBar from "./parts/TopBar";
import AnimationBlock from "./parts/AnimationBlock";
import ContrilsBlock from "./parts/ContrilsBlock";
import ControlsMenu from "./parts/ControlsMenu";
import Share from "./parts/controls/Share";
import AfterShare from "./parts/AfterShare";
import CreateEmail from "./parts/CreateEmail";
import StartBlock from './StartBlock';
import Error from "./parts/Error";
import {Share as share} from "../actions/update";
import ShareStart, {ShareStartComponent} from "./parts/controls/ShareStart";
import {userCanShare} from "../functions";


class ContainerComponent extends React.Component {
	state = {};

	constructor(props) {
		super(props);
	}

	screens = {
		start : ()=>{
			return (
				<StartBlock/>
			);
		},

		gloop : ()=>{
			return (
				<div className={'gloop-content' + ((this.props.activeScreen == 'share' || this.props.activeScreen == 'shareStart' || this.props.activeScreen == 'afterShare') ? ' blur' : '')}>
					<TopBar/>
					<AnimationBlock/>
					<ContrilsBlock/>
					<ControlsMenu/>
				</div>
			)
		},
		share : () =>{
			return (
				<Share/>
			)
		},
		shareStart : () => {
			return (
				<ShareStart/>
			)
		},
		afterShare : () => {
			return (
				<AfterShare/>
			);
		},
		errorScreen: () => {
			return (
				<Error/>
			);
		},
		createMail : () => {
			return(
				<CreateEmail/>
			);
		}
	}


	render() {
		const {active,activeGloopOptions,activeScreen, ui ,error} = this.props;
		const loading = (!activeGloopOptions || activeGloopOptions.status == 'loading') ? ' loading' : '' ;
		return active ? (
			<div className={'gloop-popup'}>
				<div onClick={() => {
					window.jQuery('body').css({position : 'static'});
					deactivate();
				}} className={'gloop-overlay'}>
				</div>
				{ !error ?
					<div className={('gloop-container' /*+ loading*/)}>
					{/*{ui.loading ? (*/}
						<div className={'loading'+(ui.loading ? ' show' : ' hidden-loading')}>
							{/*<p>Please wait...</p>*/}
							<iframe src="https://toing.io/wp-content/plugins/gloop-addons/images/toing_loader/toing-loader.html" frameborder="0"></iframe>
							{/*<img src={'https://toing.io/wp-content/plugins/gloop-addons/images/toing_loader/toing-loader.html'}*/}
							{/*     width={'100%'}/>*/}
						</div>
					{/*) : ''}*/}
					{this.screens[activeScreen]()}
						{(activeScreen == 'share') ? this.screens.gloop() : ''}
						{(activeScreen == 'shareStart' || activeScreen == 'afterShare') ? <div className={'blur'}>{this.screens.start()}</div> : ''}
						<span className={"upgrade-info"} id={'upgrade-info'}>
											{(!window.UserId) ? <><a href="https://toing.io/login/">Login</a> or <a href="https://toing.io/login/?action=register">register</a> gain access to all the fun customization feature.</> : <>Upgrade to Pro or get a new Punchcard</>}
										</span>
				</div>
					:
					<div className={('gloop-container' /*+ loading*/)}>
						<Error/>
					</div>
				}
			</div>
		) : null
	}
}


const mapStateToProps = (state) => {
	let gloop = state.gloopsOptions[state.activeGloop];
	return {
		active: state.active,
		activeGloopOptions : gloop,
		activeScreen : state.activeScreen,
		ui : state.ui,
		error : state.error
	};
}
const Container = connect(mapStateToProps)(ContainerComponent)
export default Container;
